// extracted by mini-css-extract-plugin
module.exports = {"div":"products_in_category_div__2HZKy","spinnerPos":"products_in_category_spinnerPos__2Hard","header":"products_in_category_header__qd06Z"};